
const isDeepEqual = (left, right) => {
  return JSON.stringify(left) === JSON.stringify(right)
}

const duplicator = obj => {
  return JSON.parse(JSON.stringify(obj))
}

export {
  isDeepEqual,
  duplicator
}